import CustomSwitch from '../../../../components/Switch/Switch';

const FeeSwitch = ({
  initialSaasFeeEnabled,
  onSaasFeeEnabledChange,
  billingCycle,
  handleBillingCycleChange,
}: {
  initialSaasFeeEnabled: 'Yes' | 'No';
  onSaasFeeEnabledChange: (value: 'Yes' | 'No') => void;
  billingCycle: 'Monthly' | 'Annually';
  handleBillingCycleChange: (value: 'Monthly' | 'Annually') => void;
}) => {
  return (
    <>
      <div style={styles.container}>
        <CustomSwitch
          checked={initialSaasFeeEnabled === 'Yes'}
          onChange={() => onSaasFeeEnabledChange(initialSaasFeeEnabled === 'Yes' ? 'No' : 'Yes')}
        />
        <div style={{ width: '0.8vh' }} />
        <div
          style={{
            fontSize: '1.4vh',
            fontWeight: '700',
            color: '#101D3B',
            textAlign: 'left',
          }}
        >
          Platform
          <br />
          Fee Billed
        </div>
        <div style={{ flex: 1 }} />
        {initialSaasFeeEnabled === 'Yes' && (
          <div
            style={{
              display: 'flex',
              backgroundColor: 'rgba(16, 29, 59, 0.05)',
              borderRadius: '0.8vh',
              padding: '0.3vh',
              height: '3.2vh',
            }}
          >
            <button
              onClick={() => handleBillingCycleChange('Monthly')}
              style={{
                padding: '0 1.2vh',
                borderRadius: '0.8vh',
                border: 'none',
                backgroundColor: billingCycle === 'Monthly' ? 'white' : 'transparent',
                color: billingCycle === 'Monthly' ? '#00AB9B' : 'rgba(16, 29, 59, 0.6)',
                fontSize: '1.4vh',
                fontWeight: '700',
                cursor: 'pointer',
                transition: 'all 0.2s',
              }}
            >
              Mo.
            </button>
            <button
              onClick={() => handleBillingCycleChange('Annually')}
              style={{
                padding: '0 1.2vh',
                borderRadius: '0.8vh',
                border: 'none',
                backgroundColor: billingCycle === 'Annually' ? 'white' : 'transparent',
                color: billingCycle === 'Annually' ? '#00AB9B' : 'rgba(16, 29, 59, 0.6)',
                fontSize: '1.4vh',
                fontWeight: '700',
                cursor: 'pointer',
                transition: 'all 0.2s',
              }}
            >
              Yr.
            </button>
          </div>
        )}
      </div>
    </>
  );
};

const styles = {
  container: {
    display: 'flex',
    padding: '0 1.6vh',
    justifyContent: 'start',
    width: '100%',
    alignItems: 'center',
    boxSizing: 'border-box' as const,
  },
  label: {
    color: '#101D3B',
    fontSize: '1.4vh',
    fontWeight: '700',
  },
};

export default FeeSwitch;
